//OTHERS
import MinifiedServices from "./Minified.services";
import TopLevelCacheServices from "./TopLevelCache.services";
import { useAPI, useHelper } from "@sqreem-frontend/sqapp";

//REDUX
// import store from "../store/store";

// eslint-disable-next-line react-hooks/rules-of-hooks
const SqAPI = useAPI();

class WhiteSpaceCacheServices {
    constructor() {
        this.cacheList = {};
    }

    async getCacheItem(path) {
        const errorRes = {
            hashId: "error",
            resData: {}
        };
        return await new Promise(async (resolve, reject) => {
            await this.getFile(path, "api-result-inihaw")
                .then((resp) => {
                    return resolve(resp || errorRes);
                })
                .catch((e) => {
                    console.log(e);
                    return errorRes;
                });
        });
    }

    async cacheNewItem(reqObj, resData, categName, filename) {
        const hashId = await MinifiedServices.getHashId(reqObj);
        const bucketpath = `${TopLevelCacheServices.getCacheCountryPath()}${categName}`
        const reqParam = JSON.stringify({
            hashId,
            resData
        });
        try {
            return new Promise(async (resolve, reject) => {
                await SqAPI.s3PutObject(
                    "api-result-inihaw",
                    `${bucketpath}/${hashId}${filename ? "~" + filename : ""}.json`,
                    reqParam,
                    {}
                );
                return resolve({ isSuccess: true });
            });
        } catch (error) {
            return Promise.reject({ isSuccess: false });
        }
    }

    async initScan(reqObj, categName, filename) {
        if (window.useS3Cache === false) return {
            cached: false
        }
        const bucketpath = `${TopLevelCacheServices.getCacheCountryPath()}`
        const hashId = await MinifiedServices.getHashId(reqObj);
        const path = `${bucketpath}${categName}/${hashId}${filename ? "~" + filename : ""}.json`
        return await this.getCacheItem(
            path,
        ).then((res) => {
            const { hashId, resData } = res
            return {
                cached: hashId !== "error",
                resData,
            }
        });
    }

    async getFile(path, bucket = "inihaw") {
        return await SqAPI.s3GetObject(bucket, path, {
            ResponseCacheControl: "no-cache",
        })
            .then((resp) => {
                const { Body } = resp;
                let returnObj = {};
                returnObj = Body ? JSON.parse(Body.toString("utf-8")) : {};
                return returnObj;
            })
            .catch(() => {
                return null;
            });
    }
}

export default new WhiteSpaceCacheServices();
